import { useAsyncValue, useSubmit } from 'react-router-dom';
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import NewWorkOrderForm from '../../../../components/forms/NewWorkOrderForm';
import { ContentContainer } from '../components/MainStyledComponents';

// Utils
import { createFormDataFromValues } from '../../../../utils/forms';

// Types
import { type WorkOrder } from '../../../../types/workOrder';
import { formOrderNaming } from '../../../../components/forms/NewWorkOrderForm/constants';

/**
 * Crear OT dentro de un tram de recorrido de vigilancia.
 * Reutiliza NewWorkOrderForm (mismo que Work Orders y Campaigns).
 */
export default function NewSurveillanceRouteOrderPage(): JSX.Element {
  const { t } = useTranslation('forms');
  const loaderData = useAsyncValue() as WorkOrder;
  const submit = useSubmit();

  const onFormSubmit = async (values: WorkOrder) => {
    const formData = createFormDataFromValues(values);
    submit(formData, {
      method: 'POST',
      action: 'summary',
    });
  };

  return (
    <ContentContainer>
      {/* Esta pantalla crea una OT dentro de un tramo — NO es la Actuación
          básica del RV (esa va por `NewActionPage`, `…/new-action`, que sí
          pasa `isAction` + `registeredByRequired`). Llevaba
          `registeredByRequired` por confundirla con ella, y como aquí no se
          pasa `isAction`/`isAccident` el campo "Registrado por" ni siquiera se
          pinta (`NewWorkOrderForm/Description.tsx`): el formulario exigía un
          valor que el usuario no tenía forma de introducir, así que el
          Continuar no pasaba nunca. Una OT no lleva ese campo — igual que el
          propio Recorregut tampoco (aclaración del usuario 2026-08-05). */}
      <NewWorkOrderForm
        onFormSubmit={onFormSubmit}
        initialData={loaderData}
        namingPersistForm={formOrderNaming.NEW_SURVEILLANCE_ROUTE_ORDER_FORM}
        titleBasicInfo={t('basicInfo')}
      />
    </ContentContainer>
  );
}
